<template>
  <div>
    <textarea
      :disabled="disabled"
      v-bind="$attrs"
      v-on:input="changevaloninput()"
      v-on:blur="changevalonblur()"
      v-focus="focus"
      ref="input"
      :value="value"
      class="text form-control"
    ></textarea>
  </div>
</template>

<script>
import autosize from 'autosize'
export default {
  name: 'XVtextarea',
  inheritAttrs: false,
  props: {
    focus: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    formdata: {},
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    setTimeout(() => {
      autosize(this.$refs.input)
    }, 500)
    setTimeout(() => {
      autosize(this.$refs.input)
    }, 1500)
  },
  methods: {
    changevaloninput: function() {
      this.$emit('input', this.$refs.input.value)
    },
    changevalonblur: function() {
      this.$emit('formvaluechanged', {
        type: this.$vnode.componentOptions.tag,
        value: this.$refs.input.value,
        id: this.id,
        formdata: this.formdata
      })
    }
  }
}
</script>
